<template>
  <transition name="quick-fade">
    <section id="download" class="o-section o-modal c-download" v-if="downloadOpen">
      <header class="o-modal__tools">
        <span class="o-modal__close">
          <button @click="closeDownload">
            <svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg>
          </button>
        </span>
      </header>
      <div class="o-modal__content">
        <div class="o-section__container">
          <div class="c-download__section" v-for="(item, index) in downloadItems">
            <h2 class="o-section__title">{{ item.section }}</h2>

            <div class="o-grid o-grid--3">
              <a :href="require('@/assets/pdfs/' + key + '.pdf')" @click="downloadClicked(key)" target="_blank" class="o-grid__item c-download__item" v-for="(section, key) in item.data">
                <figure class="c-download__image">
                  <img :src="require('@/assets/images/covers/' + key + '.png')" :srcset="require('@/assets/images/covers/' + key + '.png') + ' 1x, ' + require('@/assets/images/covers/' + key + '@2x.png') + ' 2x'" width="144" height="204" :alt="section">
                </figure>
                <div class="c-download__text">
                  <p>{{ section }}</p>
                  <div class="c-download__btn">
                    <svg class="icon icon-download"><use xlink:href="#icon-download"></use></svg>
                    <span class="u-hide">Download</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
// import { IconCross, IconDownload } from '@/components/standard/my-icons'

export default {
  name: 'my-download',
  // components: {
  //   IconCross,
  //   IconDownload
  // },
  data () {
    return {
      downloadItems: [
        {
          section: 'Download full report',
          data: {
            'ukpn-annual-review-2017': 'Full Annual Report'
          }
        },
        {
          section: 'Download individual sections',
          data: {
            'ceo-introduction': 'Chief Executive’s introduction & our journey',
            'focus-areas': 'Focus areas',
            'future-energy': 'The Future Energy landscape',
            'operations': 'Our operations',
            'vision-values': 'Our vision and values',
            'people': 'Our people',
            'governance': 'Governance',
            'financial-performance': 'Our financial performance',
            'uk-power-network-services': 'UK Power Network services'
          }
        }
      ]
    }
  },
  computed: {
    downloadOpen () {
      return this.$store.state.downloadOpen
    }
  },
  methods: {
    closeDownload () {
      this.$store.commit('setDownload', false)
    },
    downloadClicked (section) {
      window.gtag('event', 'pdf_downloaded', { 'event_label': section, 'type': 'section' })
    }
  },
  watch: {
    downloadOpen (val) {
      if (val === true) {
        document.body.classList.add('u-body-lock-scroll')
      } else {
        document.body.classList.remove('u-body-lock-scroll')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyDownload.vue?29bf9bb7